export default {
    INITIALIZE_PROFILE: "initializeProfile",
    INITIALIZE_AGREEMENTS: 'initializeAgreements',
    INITIALIZE_CARD_INFO: 'initializeCardInfo',
    REGISTER_BAROCARE_USER: 'registerBarocareUser',
    FETCH_BAROCARE_NAME: 'fetchBarocareName',
    REGISTER_BAROCARE_USER_SPECIFY: 'registerBarocareUserSpecify',
    INITIALIZE_PROFILE_SPECIFY: 'initializeProfileSpecify'
}


// WEBPACK FOOTER //
// ./src/constant.js